import React, { Component } from "react";





class BirthdayItemInput extends Component {

  // ===============================================================================================
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onKeyUp  = this.onKeyUp.bind(this);
    this.onBlur   = this.onBlur.bind(this);
  }



  // ===============================================================================================
  onChange(e) {
    e.preventDefault();
    // console.log(`INTRO:\n Changing ${this.props.type} field, ${e.target.value}`);

    let value = e.target.value;

    if (this.props.type === "age") {
      value = (value).replace(/[^0-9]/gi, "");      // Allow numbers only
    }
    else {
      value = (value).replace(/[^A-Za-z& ]/gi, "");  // Allow letters, spaces, and (&) only
      value = (value).replace(/\s\s+/g, " ");        // Remove multi-whitespace
      // value = (value).replace(/  +/gi, " ");      // Remove multi-spaces
      value = (value).replace(/ and +/gi, " & ");    // Replace "and" with "&" to save some space
    }

    this.props.handleChange(this.props.type, value);
  }



  // ===============================================================================================
  onKeyUp(e) {
    e.preventDefault();

    switch (e.keyCode) {
      // case  9:  // TAB key
      case 13:  // ENTER key
      case 27:  // ESC key
        // console.log(`INTRO:\n Closing ${this.props.type} field`);
        this.input.blur();
        break;

      default:
        return;
    }
  }



  // ===============================================================================================
  onBlur(e) {
    e.preventDefault();
    // console.log(`INTRO:\n Blurring ${this.props.type} field, ${e.target.value}`);

    this.props.handleBlur(this.props.type);
  }



  // ===============================================================================================
  componentDidUpdate() {
    if (this.props.isOpen) {
      this.input.focus();
    }
  }



  // ===============================================================================================
  render() {
    return (
      <input type="text" ref={(ele) => { this.input = ele; }}
        className={"item-inputs__input" +
          ((this.props.isOpen) ? " item-inputs__input--shown" : "")}

        placeholder={ this.props.placeholder}
        value={       this.props.value}

        pattern={    (this.props.type === "age") ? "[0-9]*" : "" }
        maxLength={  (this.props.type === "age") ? "2" : "20" }

        tabIndex="-1"
        onChange={    this.onChange}
        onKeyUp={     this.onKeyUp}
        onBlur={      this.onBlur}
      />
    );
  }

}



export default BirthdayItemInput
